<template>
  <div></div>
</template>

<script>
import apiUrl from '../../../constants'
import CryptoJS from 'crypto-js'
import { getHubRoutingMode } from '../../../../services/modules/newallocationservices.js'

export default {
  name: 'RiderManagement',
  mounted () {
    // Resolve the currently selected hub first: it is needed both to check the
    // routing mode and to forward hub context to the routing-engine app.
    const hubContext = this.resolveHubContext()

    // Gate access on the hub's routing mode. Only open the routing-engine app
    // when auto routing is enabled for this hub, otherwise send the user back
    // to where they came from (falling back to the dashboard).
    getHubRoutingMode({ hubId: hubContext.hubId }, (res) => {
      const isAutoRoutingMode = !!(res && res.data && res.data.data && res.data.data.isAutoRoutingMode)
      if (isAutoRoutingMode) {
        this.openRoutingApp(hubContext)
      } else {
        // Since this component renders no UI of its own, surface the reason as a
        // toast before sending the user back.
        this.$alertify.error('This hub is not enabled for auto-routing mode.')
        this.redirectBack()
      }
    }).catch(() => {
      // On any failure resolving the routing mode, do not open the page.
      this.$alertify.error('Unable to verify routing mode for this hub. Please try again.')
      this.redirectBack()
    })
  },
  methods: {
    resolveHubContext () {
      const context = { hubId: null, hubName: '', hubCity: '' }
      try {
        const enc = localStorage.getItem('lmaccessuserdata')
        const key = localStorage.getItem('userUniqueKey')
        if (enc && key) {
          const userdetail = JSON.parse(
            CryptoJS.AES.decrypt(enc.toString(), key).toString(CryptoJS.enc.Utf8)
          )
          const hubId = (userdetail && userdetail.hubdetails) ? userdetail.hubdetails[0] : null
          if (hubId !== null && hubId !== undefined && hubId !== '') {
            context.hubId = hubId
            // Resolve the hub's name + city from the cached access list so the
            // routing-engine app can label/centre the map even before it calls
            // getaccesshublist itself.
            const hubEnc = localStorage.getItem('allhubaccesslist')
            if (hubEnc) {
              const hubList = JSON.parse(
                CryptoJS.AES.decrypt(hubEnc.toString(), key).toString(CryptoJS.enc.Utf8)
              )
              if (Array.isArray(hubList)) {
                const match = hubList.find(h =>
                  String(h.HubID != null ? h.HubID : (h.HubId != null ? h.HubId : h.hubId)) === String(hubId))
                if (match) {
                  context.hubName = match.HubName || match.hubName || match.HubCode || ''
                  context.hubCity = match.HubCity || match.hubCity || match.city || ''
                }
              }
            }
          }
        }
      } catch (e) {
        console.warn('[RiderManagement] could not resolve selected hub for redirect:', e && e.message)
      }
      return context
    },
    openRoutingApp (hubContext) {
      const baseUrl = (apiUrl.shipmentAllocationV3Url || '').replace(/\/+$/, '') + '/affinity'
      const params = new URLSearchParams()
      // No auth token is forwarded: the routing-engine app authenticates itself
      // via shared Kavach/Keycloak SSO (silent check-sso). We only pass hub
      // context below so it opens on the same hub the user has selected here.
      if (hubContext.hubId !== null && hubContext.hubId !== undefined && hubContext.hubId !== '') {
        params.set('hubId', String(hubContext.hubId))
        if (hubContext.hubName) params.set('hubName', hubContext.hubName)
        if (hubContext.hubCity) params.set('hubCity', hubContext.hubCity)
      }
      const qs = params.toString()
      // Open in a NEW tab (mirrors the B2B portal redirect UX). Then send the
      // dashboard tab back to its landing route so the user is not left on this
      // blank redirect component.
      window.open(qs ? (baseUrl + '?' + qs) : baseUrl, '_blank')
      this.$router.replace('/dashboard')
    },
    redirectBack () {
      // Keep the user where they were: go back if there is history, otherwise
      // fall back to the dashboard.
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace('/dashboard')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/components/ridermanagement/index.vue?2fdaf813